<template>
  <Modal
      v-model="_value"
      width="350"
      title="表格列设置"
      @on-visible-change="visibleChange"
      ok-text="保存"
      @on-ok="onOk">
    <div>
      <Row>
        <Button size="small" style="margin-right: 5px;" type="default" @click="onSelectAll">全选</Button>
        <Button size="small" style="margin-right: 5px;" type="default" @click="onUnselectAll">全反选</Button>
        <Button size="small" type="default" @click="onReset">还原初始设置</Button>
      </Row>
      <Row style="margin-top: 5px;">
        <div class="drag-box-card">
          <div class="drag-list-wrapper">
            <div class="drag-list-con con1">
              <draggable class="drop-box" :options="options" :value="columns" @input="handleListChange($event)" @end="handleEnd($event)">
                <div class="drag-item" v-for="(item, index) in columns" :key="`drag_li1_${index}`">
                  <div style="padding-left: 10px; display: inline-block; border-radius: 5px; border: 1px solid #eeeeee; background-color: #ffffff; width: 100%;">
                    <Checkbox v-model="item.visible">{{item.title}}</Checkbox>
                  </div>
                </div>
              </draggable>
            </div>
          </div>
        </div>
      </Row>
    </div>
  </Modal>
</template>
<script>
import Vue from 'vue'
import store from '@/store'
import draggable from 'vuedraggable'

export default {
  name: 'webtablecolumnsmodal',
  components: {
    draggable
  },
  props: {
    columnList: {
      type: Array,
      required: true
    },
    tableName: {
      type: String,
      required: true
    },
    value: {
      type: Boolean,
      default: false
    }
    // dropConClass: {
    //   type: Object,
    //   default: () => ({})
    // }
  },
  data () {
    return {
      columnListBackup: [],
      columns: [],
      options: { group: 'drag_list' }
    }
  },
  methods: {
    onReset () {
      if (this.columnListBackup) {
        this.columns = []
        for (let i = 0; i < this.columnListBackup.length; i++) {
          this.columns.push({
            title: this.columnListBackup[i].title,
            index: i,
            visible: true
          })
        }
      }
    },
    onSelectAll () {
      this.columns.forEach(item => {
        item.visible = true
      })
    },
    onUnselectAll () {
      this.columns.forEach(item => {
        item.visible = false
      })
    },
    onOk () {
      let result = []
      // 更新index
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].index = i
      }
      // 设置显示
      let showColumns = this.columns.filter(item => { return item.visible })
      // 显示列
      showColumns.forEach(item => {
        for (var i = 0; i < this.columnListBackup.length; i++) {
          if (item.title === this.columnListBackup[i].title) {
            result.push(this.columnListBackup[i])
            break
          }
        }
      })

      this.saveWebTableColumns()

      this.$emit('update:columnList', result)
      this.$emit('on-column-update')
    },
    visibleChange (val) {
      if (val) {
        this.loadWebTableColumns()
      }
    },
    handleListChange (value) {
      this.columns = value
      // this.$emit('update:columns', value)
    },
    handleEnd (event) {
      // this.$emit('on-change', {
      //   oldIndex: event.oldIndex,
      //   newIndex: event.newIndex
      // })
    },
    saveWebTableColumns () {
      store.dispatch('WebTableColumnsServ_SaveWebTableColumns', {
        params: { tableName: this.tableName, tableColumns: JSON.stringify(this.columns) },
        urlparams: null
      }).then(() => {
        this.$Message.success('保存列表成功')
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    loadWebTableColumns () {
      this.columns = []
      store.dispatch('WebTableColumnsServ_GetByTableName', {
        params: { tableName: this.tableName },
        urlparams: null
      }).then(() => {
        let webTableColumns = store.getters.get_WebTableColumns_GetByTableNameResult
        if (webTableColumns && webTableColumns.tableColumns && webTableColumns.tableColumns != '') {
          let tableColumns = JSON.parse(webTableColumns.tableColumns)
          tableColumns.forEach(item => {
            this.columns.push(item)
          })
          let result = []
          // 设置显示
          let showColumns = this.columns.filter(item => { return item.visible })
          // 显示列
          showColumns.forEach(item => {
            for (var i = 0; i < this.columnListBackup.length; i++) {
              if (item.title === this.columnListBackup[i].title) {
                result.push(this.columnListBackup[i])
                break
              }
            }
          })
          this.$emit('update:columnList', result)
          this.$emit('on-column-update')
        } else {
          for (let i = 0; i < this.columnList.length; i++) {
            this.columns.push({
              title: this.columnList[i].title,
              index: i,
              visible: true
            })
          }
        }
      }).catch(err => {
        this.$Message.error(err)
      })
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadWebTableColumns()
      if (this.columnListBackup.length <= 0) {
        this.columnList.forEach(item => {
          this.columnListBackup.push(item)
        })
      }
    })
  }
}
</script>
<style lang="less">
  .drag-list-wrapper{
    height: 100%;
    .drag-list-con{
      width: 50%;
      float: left;
    }
  }
  .drag-box-card{
    display: inline-block;
    width: 600px;
    height: 450px;
    .drag-item{
      margin: 5px;
    }
    h3{
      padding: 10px 15px;
    }
    .drop-box{
      border: 1px solid #eeeeee;
      height: 455px;
      border-radius: 5px;
    }
  }
</style>
